import { render, staticRenderFns } from "./TaskDoneModal.vue?vue&type=template&id=19463900&scoped=true"
import script from "./TaskDoneModal.vue?vue&type=script&lang=js"
export * from "./TaskDoneModal.vue?vue&type=script&lang=js"
import style0 from "./TaskDoneModal.vue?vue&type=style&index=0&id=19463900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19463900",
  null
  
)

export default component.exports